import { Link, useSearchParams } from 'react-router-dom';
import LogoSquare from '../components/logo-square';
import { CheckCircle2 } from 'lucide-react';

export default function CheckoutSuccessPage() {
  const [searchParams] = useSearchParams();
  const paymentId = searchParams.get('payment_id');

  return (
    <div className="min-h-screen bg-neutral-50 dark:bg-neutral-900 flex flex-col items-center justify-center px-4 py-12">
      <div className="w-full max-w-md text-center">
        <Link to="/" className="inline-block mb-8">
          <LogoSquare />
        </Link>
        <div className="rounded-2xl border border-neutral-200 bg-white p-8 shadow-sm dark:border-neutral-700 dark:bg-neutral-800">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-green-100 dark:bg-green-900/30">
            <CheckCircle2 className="h-10 w-10 text-green-600 dark:text-green-400" />
          </div>
          <h1 className="mb-2 text-xl font-semibold text-neutral-900 dark:text-white">
            Paiement réussi
          </h1>
          <p className="mb-6 text-sm text-neutral-600 dark:text-neutral-400">
            Merci pour votre commande. Nous avons bien reçu votre paiement.
            {paymentId && (
              <span className="mt-2 block font-mono text-xs text-neutral-500 dark:text-neutral-500">
                Réf. {paymentId}
              </span>
            )}
          </p>
          <Link
            to="/"
            className="inline-block w-full rounded-full bg-gradient-to-r from-[#ff0442] to-[#ff1a4d] px-6 py-3 text-center text-sm font-medium text-white hover:opacity-95"
          >
            Continuer les achats
          </Link>
        </div>
      </div>
    </div>
  );
}
